export const defaultValueColumnDef = {
  minWidth: 150,
  attrAvailableInGrid: true,
  formOrderNo: 1,
  attrInternalName: 'default_value',
  attrDisplayNameen: 'Default Value',
  attrDisplayNamede: 'Default Value',
  attrDataType: 'string',
  attrDuplicateConfig: '',
  attrMaxValue: 64,
  attrMinValue: 0,
  attrMinWidth: null,
  attrMandatory: false,
  mutationColumnName: null,
  mutationTableName: '',
  mutationTablePkey: '',
  editable: true,
  sortable: true,
  headerName: 'Default Value',
  label: 'Default Value',
  field: 'default_value',
  type: 'string',
  required: true,
  headerAlign: 'centre',
  flex: 1,
  maxWidth: 150,
  id: 506,
  renderCell: (params) => {
    const { row } = params;
    const { default_value } = row;
    return <div>{default_value}</div>;
  },
};
 
export const customSorting = {
  sortModel: [
    {
      field: 'default_value',
      sort: 'asc',
    },
  ],
};
export const overwriteFeature = {
  pkey_column: 'id',
  filtering: false,
  dataexport: false,
  page_per_rows: true,
  viewmanagement: false,
  singledatasetgroup: false,
  panel_cbtn: false,
  no_of_rows_per_page: 100,
  addrow: false,
  clonerow: false,
  deleterow: false,
  editrow: true,
  savedata: true,
};
 